export default "__VITE_ASSET__ClB2$a$G__"